<template>
  <div class="component-map__right">
    <div class="component-map__right--top">
      <CollapseLateral
        id="lateral__collapse__maps"
        orientation="down-left"
        autoclose
        text-tooltip="Mapas"
      >
        <template #icon>
          <span class="material-icons">
            map
          </span>
        </template>
        <template #title>
          <h4>Mapas</h4>
        </template>
        <div class="component-map__right__maps">
          <h5 class="mb-3">
            Mapas base
          </h5>
          <div
            v-for="(item, key) in GROUP_BASE_MAPS?.getLayers().getArray()"
            :key="key + GROUP_OVER_MAPS.getProperties().name"
            class="component-map__right__maps__group-radio"
          >
            <RadioButton
              v-model="mapSelectedRef"
              class="component-map__right__maps__group-radio__radio"
              :name="GROUP_BASE_MAPS?.getProperties().name"
              :value="item"
              :input-id="String(item.getProperties().values.id)"
              @click="(event) => onChangeBaseMap(event, item)"
            />
            <label :for="String(item.getProperties().values.id)">
              {{ item.getProperties().values.description }}
            </label>
          </div>
        </div>
        <div
          v-if="GROUP_OVER_MAPS.getLayers().getLength()>0"
          class="component-map__right__maps"
        >
          <h5 class="mb-3">
            Capas
          </h5>
          <div
            v-for="(item, key) in GROUP_OVER_MAPS.getLayers().getArray()"
            :key="key + GROUP_OVER_MAPS.getProperties().name"
            class="component-map__right__maps__group-checkbox"
          >
            <Checkbox
              v-model="overMapSelectedRef"
              class="component-map__right__maps__group-checkbox__checkbox"
              :name="GROUP_OVER_MAPS.getProperties().name"
              :value="item"
              :input-id="String(item.getProperties().values.id)"
              @click="(event) => onChangeOverMap(event, item)"
            />
            <label :for="String(item.getProperties().values.id)">
              {{ item.getProperties().values.description }}
            </label>
          </div>
        </div>
      </CollapseLateral>
      <CollapseLateral
        id="lateral__collapse__layers--group"
        class="mt-2"
        orientation="down-left"
        autoclose
        text-tooltip="Capas de carreteras"
        :disabled="collapseButtonDisabled"
        width="350px"
      >
        <template #icon>
          <span class="material-icons">
            account_tree
          </span>
        </template>
        <template #title>
          <h4>Capas carreteras</h4>
        </template>
        <Tree
          selection-mode="checkbox"
          :options="optionsTreeRef"
          label-key="values.description"
          active-key="values.default"
          children-key="values.children"
          identificator-key="values.id"
          @item-selected="onChangeLayerGroup"
        ></Tree>
      </CollapseLateral>
      <CalcRoutesControl
        :user-layers="userLayers"
      />
      <MapRightLayers
        class="mt-2"
      />
    </div>
    <div class="component-map__right--bottom">
      <SliderMap
        :value="modelMapRef.zoom"
        :min-value="modelMapRef.minZoom"
        :max-value="modelMapRef.maxZoom"
        @change="(zoom) => emits('changeZoom', zoom)"
      />
      <div
        id="content__google__captcha"
        class="content__google__captcha"
      ></div>
    </div>
  </div>
</template>


<script setup>
import {inject, ref, watch, watchEffect, computed} from 'vue';

// sttedra
import {CollapseLateral} from '@sttedra_ui/framework';

// Openlayers
import {Group as LayerGroup} from 'ol/layer';

// Components
import SliderMap from '../Slider.Map';
import Tree from '@/components/Tree/Tree';
import MapRightLayers from './layers/MapRight.Layers';
import CalcRoutesControl from '@/components/calc-routes-control/CalcRoutesControl';

// PrimeVue
import RadioButton from 'primevue/radiobutton';
import Checkbox from 'primevue/checkbox';

// #region Props, Emits
const emits = defineEmits(['changeZoom']);
const props___ = defineProps({
  layersGroup: {
    type: Array,
    default: () => {
      return [];
    },
  },
  userLayers: {
    type: Array,
    default: () => {
      return [];
    },
  },
});
// #endregion


// #region Params, Ref, Reactives, Computed
const modelMapRef = inject('modelMapRef');
const GROUP_BASE_MAPS = inject('GROUP_BASE_MAPS');
const GROUP_OVER_MAPS = inject('GROUP_OVER_MAPS');
const GROUP_LAYERS = inject('GROUP_LAYERS');

const mapSelectedRef = ref(null);

const overMapSelectedRef = ref([]);
const optionsTreeRef = ref([]);
const minZoomRef = ref(1);

const collapseButtonDisabled = computed(() => minZoomRef.value >= modelMapRef.zoom);
// #endregion


// #region Functions
/**
 * Event when a overMaps has been updated
 * Update the LayerGroup: GROUP_BASE_MAPS
 *
 * @param {Event} _event
 * @param {Object} item
 */
function onChangeBaseMap(_event, item) {
  GROUP_BASE_MAPS.getLayers().forEach((layer) => {
    layer.setVisible(layer === item);
    if (layer.getVisible()) {
      mapSelectedRef.value = layer;
    }
  });

  const groupBaseMap = GROUP_BASE_MAPS.getLayers().getArray().find((layer) => {
    if (layer.getVisible()) {
      return layer;
    }
  });

  if (groupBaseMap && groupBaseMap instanceof LayerGroup) {
    groupBaseMap.getLayers().getArray().forEach((layer) => {
      if (layer.getMaxZoom() <= modelMapRef.value.zoom) {
        layer.setVisible(false);
      } else if (layer.getMaxZoom() >= modelMapRef.value.zoom) {
        layer.setVisible(true);
      }
    });
  }
}

/**
 * Event when a overMaps has been updated
 * Update the LayerGroup: GROUP_OVER_MAPS
 *
 * @param {Event} _event
 * @param {Object} item
 */
function onChangeOverMap(_event, item) {
  overMapSelectedRef.value = [];
  GROUP_OVER_MAPS.getLayers().forEach((layer) => {
    if (layer === item) {
      layer.setVisible(!layer.getVisible());
    }
    if (layer.getVisible()) {
      overMapSelectedRef.value.push(layer);
    }
  });
}

/**
 * Event when a item has been selected.
 * Update the LayerGroup: GROUP_LAYERS
 *
 * @param {Object} item
 *
 */
function onChangeLayerGroup(item) {
  GROUP_LAYERS.getLayers().getArray().forEach((layer) => {
    if (layer.getProperties().values.id === item.values.id) {
      layer.setVisible(item.values.default);
    }
  });
}

/**
 * Prepare the structure of the Tree
 *
 * @param {Array} options
 */
function setOptionsTree(options) {
  minZoomRef.value = 1;
  const parents = [];
  const hasParents = [];
  options.map((item) => {
    if (item.values.parentId === null) {
      parents.push(item);
    } else {
      hasParents.push(item);
    }
    if (item.minZoom > minZoomRef.value) {
      minZoomRef.value = item.minZoom;
    }
  });
  parents.forEach((parent) => {
    parent = setChildren(parent, hasParents);
  });
  optionsTreeRef.value = parents;
}

/**
 * Set the children to the item
 *
 * @param {Object} parent
 * @param {Array} items
 *
 * @return {Object}
 */
function setChildren(parent, items) {
  let children = items.map((item) => {
    // Check if the item is not in the loop
    if (parent.values.id !== item.values.id && item.values.parentId === parent.values.id) {
      item = setChildren(item, items);
      return item;
    }
  });
  children = children.filter((child) => child);
  if (children && children.length > 0) {
    parent.values.children = children;
  }
  return parent;
}
// #endregion


// #region Effects, Hooks

watchEffect(() => {
  mapSelectedRef.value = GROUP_BASE_MAPS?.getLayers().getArray().find((layer) => {
    return layer.getVisible();
  });
  overMapSelectedRef.value = GROUP_OVER_MAPS.getLayers().getArray().filter((layer) => {
    return layer.getVisible();
  });
});

watch(props___, () => {
  setOptionsTree(props___.layersGroup);
});
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.component-map__right{
  position: absolute;
  z-index: 9;
  right: 0;
  top: 0;
  padding: 10px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;

  & #lateral__collapse__maps {
    display: none;
  }
  & :deep(.lateral-collapse-container__contain) {
    padding: 0;
    transition: none;
  }
  &--top {
    top: 0;
  }

  &--bottom {
    display: none;
    bottom: 0;
    width: fit-content
  }

  &__maps{
    margin-top: 10px;

    &__group-radio {
      margin-top: 10px;
      display: flex;
      align-items: center;

      &__radio {
        margin-right: 5px;
      }
    }
    &__group-checkbox {
      margin-top: 10px;
      display: flex;
      align-items: center;

      &__checkbox {
        margin-right: 5px;
      }
    }
  }
}

.maps {
  &__base {
    margin: 5px 0;
  }
}

.content__google__captcha {
  padding: 5px;
  position: relative;
}
.route-layers-list {
  &__title-container {
    padding: 0.5rem 2rem;
  }
  &__container {
    margin: 0 0.5rem;
  }
  &__head, &__list-content {
    margin: 1rem 0.5rem;
  }
  &__route-info-container {
    display: flex;
    justify-content: left;
    align-items: center;
  }
  &__route-name {
    display: block;
    padding: 0.2rem 0.4rem 0.2rem 0;
  }

}
</style>
